export const upper = {
  bind: function (el, binding) {
    el.addEventListener('keyup', function (event) {
      event.target.value = event.target.value.toUpperCase()
      binding.value.set[binding.value.name] = event.target.value
    })
  }
}

export const drag = {
  bind: function (el, binding) {
    let _el = el
    document.getElementById(_el.id) && document.getElementById(_el.id).remove()
    document.body.appendChild(_el)
    _el.addEventListener('mousedown', function (event) {
      let disX = event.clientX - _el.offsetLeft
      let disY = event.clientY - _el.offsetTop

      document.onmousemove = function (e) {
        let x = e.clientX - disX
        let y = e.clientY - disY
        let r = window.screen.width - el.clientWidth

        // move current element
        x = x < 0 ? 0 : (x > r ? r : x)
        y = y < 0 ? 0 : y

        _el.style.left = x + 'px'
        _el.style.top = y + 'px'

        //
        // binding.value({x: e.pageX, y: e.pageY})
      }
      document.onmouseup = function (e) {
        document.onmousemove = null
        document.onmouseup = null
      }
    })
  }
}

export const err = {
  bind: function (el, binding) {
    el.addEventListener('keyup', function (event) {
      let reg = event.target.dataset['reg']
      // let regex = new RegExp(reg)
      console.log(binding)
      console.log(reg)
      if (!reg.test(event.target.value)) {
        console.log('error')
        event.target.style = 'background-color:red;color:#FFF;'
      } else {
        console.log('ok')
        event.target.style = 'background-color:#FFF;color:#999;'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/directive/index.js